import { gql } from "@apollo/client";

export const GET_ALL_TIPO_ZONA = gql`
query allTipoZona{
    allTipoZona{
        idTipoZona,
        descripcion
      }
  }
`;